/**
 * Central source of truth for role-based routing.
 * Used by AppRouter's RootRedirect, LoginPage post-submit, ProtectedRoute
 * cross-role fallback, and NavBar signed-in home link.
 */
export function homePathForRole(role) {
  if (role === "super_admin") return "/super-admin";
  if (role === "club_admin" || role === "golf_shop_staff") return "/admin";
  if (role === "vendor") return "/vendor";
  return "/dashboard";
}

/** Where to send an anonymous visitor to sign in when they hit a role-gated route. */
export function loginPathForRole(role) {
  if (role === "club_admin" || role === "golf_shop_staff") return "/admin/login";
  if (role === "super_admin") return "/super-admin/login";
  return "/login"; // members + vendors both sign in here
}

/** Roles allowed when a route requires "club staff" access. */
export const CLUB_STAFF_ROLES = new Set(["club_admin", "golf_shop_staff"]);

/**
 * Middleware check — is the current user's role allowed for a route
 * that requires `required`? Enforces the cross-role rules from Prompt 1:
 *   - Members can't access Club pages, Vendor pages, or Admin pages.
 *   - Vendors can't access Member pages or Club pages.
 *   - Club Staff can't access Vendor pages.
 *   - Only Super Admin can access everything.
 */
export function isRoleAllowed(required, actual) {
  if (!required) return true;
  if (actual === "super_admin") return true; // SA sees all
  if (required === "club_admin") return CLUB_STAFF_ROLES.has(actual);
  return required === actual;
}
